import React, { useRef } from "react"
import cogoToast from "cogo-toast"
import { useGetUserGroupsQuery } from "../../../../../redux/apiSlice";

const Tab1 = ({ tab, setTab, userData, addTabData }) => {

    const { data: userGroups } = useGetUserGroupsQuery();
    const passwordReq = useRef(!userData?.tab1?.basic?.userId);

    /* Extract Submit data */
    const handleSubmit = e => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;

        if (form.checkValidity() === true) {
            const formData = new FormData(form);
            const obj = Object.fromEntries(formData.entries());
            const tab1Data = {};

            /* ID Check */
            if (obj.idType && obj.idValue) {
                tab1Data.identificationData = {
                    "type": obj.idType,
                    "value": obj.idValue
                }

            }
            else if (obj.idType || obj.idValue) {
                return cogoToast.error("ID Type and Value required as pair");
            }

            delete obj.idType;
            delete obj.idValue;
            tab1Data.basic = { ...obj, userId: userData?.tab1?.basic?.userId };
            addTabData({ tab1: tab1Data });
            setTab(2);
        }
    }

    return <form
        onSubmit={handleSubmit}
        className="form mt-0 mt-lg-10"
    >
        <div
            className="pb-5"
            data-wizard-type="step-content"
            data-wizard-state={tab === 1 ? "current" : ""}
        >
            <div className="mb-10 h3 font-weight-bold text-dark">User Basic Details</div>
            <div className="row">
                <div className="col-xl-12">
                    {/* <!--begin::Input--> */}
                    <div className="form-group">
                        <label>User Group</label>
                        <select
                            className="form-control form-control-solid custom-select mr-sm-2"
                            name="userGroup"
                            defaultValue={userData?.tab1?.basic?.userGroup}
                            required
                        >
                            <option value="">Select</option>
                            {userGroups?.map((userGroup, key) => <option
                                key={`userGroup-${key}`}
                                value={userGroup.groupId}
                                disabled={userData?.tab1?.basic?.userGroup && userGroup.groupId !== userData?.tab1?.basic?.userGroup}
                            >
                                {userGroup.name}
                            </option>)}
                        </select>
                    </div>
                    {/* <!--end::Input--> */}
                </div>
            </div>
            {/* <!--end::Input--> */}
            <div className="row">
                <div className="col-xl-6">
                    {/* <!--begin::Input--> */}
                    <div className="form-group">
                        <label>Username</label>
                        <input
                            type="text"
                            className="form-control form-control-solid form-control-lg"
                            name="username"
                            defaultValue={userData?.tab1?.basic?.username}
                            required
                        />
                    </div>
                    {/* <!--end::Input--> */}
                </div>
                <div className="col-xl-6">
                    {/* <!--begin::Input--> */}
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            defaultValue={userData?.tab1?.basic?.email}
                            className="form-control form-control-solid form-control-lg"
                            name="email"
                            required
                        />
                    </div>
                    {/* <!--end::Input--> */}
                </div>
            </div>
            {/* <!--end::Input--> */}

            {/* <!--end::Input--> */}
            <div className="row">
                <div className="col-xl-6">
                    {/* <!--begin::Input--> */}
                    <div className="form-group">
                        <label>First Name</label>
                        <input
                            type="text"
                            defaultValue={userData?.tab1?.basic?.firstName}
                            className="form-control form-control-solid form-control-lg"
                            name="firstName"
                        />
                    </div>
                    {/* <!--end::Input--> */}
                </div>
                <div className="col-xl-6">
                    {/* <!--begin::Input--> */}
                    <div className="form-group">
                        <label>Last Name</label>
                        <input
                            type="text"
                            defaultValue={userData?.tab1?.basic?.lastName}
                            className="form-control form-control-solid form-control-lg"
                            name="lastName"
                        />
                    </div>
                    {/* <!--end::Input--> */}
                </div>
            </div>
            {/* <!--end::Input--> */}

            <div className="row">
                <div className="col-xl-6">
                    {/* <!--begin::Input--> */}
                    <div className="form-group">
                        <label>Middle Name</label>
                        <input
                            type="text"
                            defaultValue={userData?.tab1?.basic?.middleName}
                            className="form-control form-control-solid form-control-lg"
                            name="middleName"
                        />
                    </div>
                    {/* <!--end::Input--> */}
                </div>
                <div className="col-xl-6">
                    {/* <!--begin::Input--> */}
                    <div className="form-group">
                        <label>Phone</label>
                        <input
                            type="tel"
                            defaultValue={userData?.tab1?.basic?.phone}
                            className="form-control form-control-solid form-control-lg"
                            name="phone"
                            required
                        />
                    </div>
                    {/* <!--end::Input--> */}
                </div>
            </div>

            <div className="row">
                <div className="col-xl-6">
                    {/* <!--begin::Input--> */}
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="text"
                            className="form-control form-control-solid form-control-lg"
                            name="password"
                            defaultValue={userData?.tab1?.basic?.password}
                            required={passwordReq.current}
                            autoComplete="off"
                            disabled={!passwordReq.current}
                        />
                    </div>
                    {/* <!--end::Input--> */}
                </div>
                <div className="col-xl-6">
                    {/* <!--begin::Input--> */}
                    <div className="form-group">
                        <label>ID</label>
                        <div className="row">
                            <div className="col-4 pr-0">
                                <select
                                    className="form-control form-control-solid custom-select mr-sm-2"
                                    name="idType"
                                    defaultValue={userData?.tab1?.identificationData?.type}
                                >
                                    <option value="">Select</option>
                                    <option value="BVN">BVN</option>,
                                    <option value="BVN_NG">BVN_NG</option>,
                                    <option value="NIN">NIN</option>
                                    <option value="NIN_NG">NIN_NG</option>,
                                    <option value="SSN_US">SSN_US</option>,
                                    <option value="NATIONAL_ID">NATIONAL_ID</option>,
                                    <option value="VOTERS_CARD">VOTERS_CARD</option>,
                                    <option value="DRIVERS_LICENSE">DRIVERS_LICENSE</option>,
                                    <option value="INTERNATIONAL_PASSPORT">INTERNATIONAL_PASSPORT</option>,
                                </select>
                            </div>
                            <div className="col-8">
                                <input
                                    name="idValue"
                                    defaultValue={userData?.tab1?.identificationData?.value}
                                    type="text"
                                    className="form-control form-control-solid" />
                            </div>

                        </div>
                    </div>
                    {/* <!--end::Input--> */}
                </div>
            </div>

            {/* <!--begin: Wizard Actions--> */}
            <div className="text-right border-top mt-5 pt-10">
                <div>
                    <button
                        type="submit"
                        className="btn btn-primary font-weight-bolder text-uppercase px-9 py-4"
                    >
                        Next
                    </button>
                </div>
            </div>
            {/* <!--end: Wizard Actions--> */}
        </div>
    </form>

}

export default Tab1;

